import { render } from "./InvoicesTableFilter.vue?vue&type=template&id=0c370a98"
import script from "./InvoicesTableFilter.vue?vue&type=script&lang=ts"
export * from "./InvoicesTableFilter.vue?vue&type=script&lang=ts"
script.render = render

export default script